﻿import {
	FullEntityRelation,
	getVehicleConfiguration,
	InstallationByHostData, ParkingCategory,
	VehicleId,
	VehiclePropertyFlags,
	VehicleResult
} from "@2d-front-monorepo/permits-business";

export default function getVehicleHiddenFields(installation: InstallationByHostData, vehicles: FullEntityRelation<VehicleId, VehicleResult>[], category: ParkingCategory): VehiclePropertyFlags {
	const vehicle = vehicles[0];
	if (vehicle == null) {
		return Number.MAX_SAFE_INTEGER;
	}

	const entity = vehicle.original.entity;
	return getVehicleConfiguration(installation, entity.type, category).fieldRules.hidden;
}
